import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_BEGIN,
  MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_SUCCESS,
  MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_FAILURE,
  MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function updateOutsRecordLock(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/updateOutsLock`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateOutsRecordLockError() {
  return {
    type: MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_DISMISS_ERROR,
  };
}

export function useUpdateOutsRecordLock() {
  const dispatch = useDispatch();

  const { updateOutsRecordLockPending, updateOutsRecordLockError } = useSelector(
    state => ({
      updateOutsRecordLockPending: state.manageSubs.updateOutsRecordLockPending,
      updateOutsRecordLockError: state.manageSubs.updateOutsRecordLockError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(updateOutsRecordLock(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUpdateOutsRecordLockError());
  }, [dispatch]);

  return {
    updateOutsRecordLock: boundAction,
    updateOutsRecordLockPending,
    updateOutsRecordLockError,
    dismissUpdateOutsRecordLockError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateOutsRecordLockPending: true,
        updateOutsRecordLockError: null,
      };

    case MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        updateOutsRecordLockPending: false,
        updateOutsRecordLockError: null,
      };

    case MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        updateOutsRecordLockPending: false,
        updateOutsRecordLockError: action.data.error,
      };

    case MANAGE_SUBS_UPDATE_OUTS_RECORD_LOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateOutsRecordLockError: null,
      };

    default:
      return state;
  }
}
